import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators, AbstractControl } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { AlertController, IonInfiniteScroll } from '@ionic/angular';
import { ToolsService } from 'src/app/services/tools.service';
import { ModalController } from '@ionic/angular';
import { ConfigService } from 'src/app/services/config.service';
import { AnalyticsService } from 'src/app/services/analytics.service';


@Component({
  selector: 'app-post-comments',
  templateUrl: './post-comments.page.html',
  styleUrls: ['./post-comments.page.scss'],
})
export class PostCommentsPage implements OnInit {
  @ViewChild(IonInfiniteScroll, { static: true }) infiniteScroll: IonInfiniteScroll;
  editDeleteMenu: any;

  post_id
  comments = []

  offset: any = 0;
  limit: any = 20;

  loading = false
  commentUpdated: boolean = false;

  formControl = new FormControl('', [Validators.required])

  public onEditCallback: any;
  public onDeleteCallback: any;

  constructor(
    public toolsService: ToolsService,
    public authService: AuthService,
    public socialService: ConfigService,
    public alertCtrl: AlertController,
    public modalController: ModalController,
    private analyticsService: AnalyticsService
  ) {
    this.analyticsService.AnalyticsServiceModalView('post-comments');
   }

  ngOnInit() {
    this.getComments()
  }

  async getComments() {
    this.loading = true
    if (this.offset == 0)
      await this.toolsService.showLoader();
    try {
      const response = await this.socialService.getComments(this.post_id, this.limit, this.offset);
      console.log("response.results", response)
      let aux_comments = response
      for (let post of aux_comments) {
        post.created = this.toolsService.formatDate(post.created)
      }
      this.comments = this.comments.concat(aux_comments);

      if (response.length < 20)
        this.infiniteScroll.disabled = true;
    } catch (error) {
      console.error('[MISSIONS PAGE](LoadMissions) Error comments', error);
    }
    this.offset += this.limit;
    this.infiniteScroll.complete()
    if (this.offset == this.limit)
      await this.toolsService.dismissLoader()
    this.loading = false
  }


  async createComment() {
    if (this.formControl.valid) {
      await this.toolsService.showLoader();
      try {
        let result = await this.socialService.createComment(this.formControl.value, this.authService.player_initial_data.id, this.post_id)
        console.log("result", result)
        this.socialService.notifyCommentCreated();
        this.formControl.setValue("")
        this.comments.push(result)
      } catch (error) {
        console.error(error)
      }
      this.toolsService.dismissLoader();
    }

  }

  closeModal(data: any=null) {
    this.modalController.dismiss(data);
  }


  async doRefresh(event) {
    this.offset = 0;
    this.comments = [];
    await this.getComments()
    event.target.complete();
  }

  async removeComment(comment) {
    const alert = await this.alertCtrl.create({
      header: "Eliminar publicación",
      message: "¿Estas seguro de que quieres eliminar el comentario?",
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
        },
        {
          text: 'Eliminar',
          handler: () => {
            this.deleteComment(comment);
          },
        },
      ]
    });
    alert.present()
  }

  async deleteComment(comment) {
    await this.toolsService.showLoader();
    try {
      await this.socialService.deleteComment(comment.id);
      this.comments.splice(this.comments.indexOf(comment), 1);
      this.toolsService.showSuccessToast("Comentario eliminado satisfactoriamente");
    } catch (error) {
      this.toolsService.showErrorToast("No se pudó eliminar la publicación, intenta de nuevo más tarde");
    }
    if (this.onDeleteCallback) {
      this.onDeleteCallback(comment.id, this.comments.length);
    };
    await this.toolsService.dismissLoader();
  }

  async editComment(comment) {
    const alert = await this.alertCtrl.create({
      header: "Editar comentario",
      inputs: [
        {
          name: 'comment',
          type: 'text',
          value: comment.text,
        }
      ],
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
        },
        {
          text: 'Actualizar',
          handler: (data) => {
            this.updateComment(comment.id, data.comment);
          },
        },
      ]
    });
    alert.present()
  }

  async updateComment(commentId: any, newComment: any) {
    if (newComment == "") {
      this.toolsService.showErrorToast("El comentario no puede estar vacío");
      return;
    }
    await this.toolsService.showLoader()
    try {
      let response = await this.socialService.updateComment(this.authService.player_initial_data.id, commentId, newComment);
      await this.toolsService.showSuccessToast("Comentario actualizado satisfactoriamente");
    } catch (error) {
      console.error("(EDIT POST-COMMENT PAGE) Error in editComment", error)
      this.toolsService.showErrorToast()
    }
    this.comments = this.comments.map((comment) => {
      if (comment.id == commentId) {
        comment.text = newComment;
      }
      return comment;
    });
    if (this.onEditCallback) {
      this.onEditCallback(commentId, newComment);
    };
    await this.toolsService.dismissLoader();
  }

}
